import React, { Component } from "react";
import "../assets/css/modal.css";


function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}



class DetailContent extends Component {

    constructor(props) {
        super(props);
    }


    componentDidMount() {

        /*mapboxgl.accessToken = 'pk.eyJ1Ijoib3Jpb253YW1iZXJ0IiwiYSI6ImNqeGl2c3o2MzF1bm8zeW1qMHZyOTdydjcifQ._0U6QGYxSkuc0dgW21I7lg';
        var map = new mapboxgl.Map({
            container: 'map',

            style: 'mapbox://styles/mslee/ciellcr9y001g5pknxuqwjhqm'
        });*/
    }

    render() {
        return (

            <div className="container">
                <div className="card">
                    <div className="row no-gutters">

                        <div className="tab-content img-size" id="nav-tabContent">
                            <div className="tab-pane fade card-body show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                <h5 className="card-title">{this.props.article.designation}</h5>
                                <p className="card-text">
                                    {this.props.article.description}
                                </p>

                                <hr />
                                <p className="card-text">
                                    <i className="fa blue fa-location-arrow mr-2"></i>{this.props.article.selectedArrondisement} , {this.props.article.ville}
                                </p>
                                <hr />
                                <ul className="pagination pagination-sm">
                                    <li className="page-item">

                                        <button type="button" className="page-link" data-toggle="modal" data-target="#detailmodal">
                                            <i className="fa blue fa-street-view mr-2"></i>{this.props.article.distance}  de votre position
                                     </button>


                                    </li>
                                </ul>

                                <hr />
                                <ul className="pagination pagination-sm">
                                    <li className="page-item">
                                        <button className="page-link">
                                            Téléphone : 
                                            <i className="fa blue fa-mobile mr-2"></i><span>{this.props.article.telephone}</span>
                                        </button>
                                    </li>
                                </ul>
                                <hr />

                                {this.props.article.adresse != undefined && <p>
                                    <a href="#"><i className="fa blue fa-home mr-2"></i></a>
                                    <span>{this.props.article.adresse.trim() != "" ? this.props.article.adresse : "Aucune adresse specifiée"}</span>
                                </p>}

                                <hr />

                                {this.props.article.adresseAprox != undefined && <p>
                                    <a href="#"><i className="fa blue fa-home mr-2"></i></a>
                                    <span>{this.props.article.adresseAprox}</span>
                                </p>}

                                <hr />

                                <a href={"tel:" + this.props.article.telephone} className="btn btn-primary">Appeler</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )


            ;
    }
}
/*<div class="container">
                <div class="card">
                    <div class="row no-gutters">
                        <nav class="nav-menu">
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab"
                                    aria-controls="nav-home" aria-selected="true">A propos</a>
                                <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab"
                                    aria-controls="nav-profile" aria-selected="false">Prix</a>
                                <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab"
                                    aria-controls="nav-contact" aria-selected="false">Services</a>
                            </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">

                            <APropos datas={this.props.article} />

                            <Prix datas={this.props.article} />

                            <Services datas={this.props.article} />
                        </div>
                    </div>
                </div>
            </div>*/

/*
function APropos({ datas }) {
return <div class="tab-pane fade card-body show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
<h5 class="card-title">{datas.designation}</h5>
<p class="card-text">
{datas.description}
</p>

<hr />
<p class="card-text">
<i class="fa blue fa-phone-square mr-2"></i> {datas.telephone}
</p>
<hr />
<p class="card-text">
<span>
    <i class="fa blue fa-credit-card mr-2"></i> Reservation possible par Mobile Money : {datas.telephone}
</span>
</p>
<hr />
<p>
<a href="#"><i class="fa blue fa-clock mr-2"></i></a>
<span>{datas.heureOuverture} - {datas.heureFermeture}</span>
</p>
<hr />
<p>
<a href="#"><i class="fa blue fa-map-marker mr-2"></i></a>
<span>{datas.adresse}</span>
</p>
<hr />
<p>
<a href={"mailto:" + datas.email}><i class="fa blue fa-envelope mr-2"></i></a>
<span>{datas.email}</span>
</p>
<hr />

<a href="#" class="btn btn-primary">Appeler</a>
</div>
;
}

function Prix({ datas }) {

if (datas.services != undefined) {
return (
<div class="tab-pane fade card-body" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">

    {!isEmpty(datas) && datas.services.map((service) => {
        return <React.Fragment key={service.designation}>
            <h5>{service.designation}</h5>
            <ul className="list-group mb-4">
                {service.produits.map((val) => {
                    return <li key={val.designation} className="list-group-item d-flex justify-content-between align-items-center">
                        {val.designation}
                        <span className="badge badge-primary badge-pill">{val.prix} FCFA</span>
                    </li>;
                })}
            </ul>
        </React.Fragment>;
    })}
</div>

);
} else {
datas.services=[];
return (
<div class="tab-pane fade card-body" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
</div>
);
}


}

function Services({ datas }) {
return (
<div class="tab-pane fade card-body" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
{!isEmpty(datas) && datas.services.map((service) => {
    return <div className="card mb-3">
        <div className="row no-gutters">
            <div className="col-md-4">
                <LazyLoadImage
                    src={Hotel}
                    class="img-size"
                    alt="..."
                >
                </LazyLoadImage>
            </div>
            <div className="col-md-8">
                <div className="card-body">
                    <h5 className="card-title">{service.designation}</h5>
                    <p>
                        {service.description}
                    </p>
                    <a href="motel_details.html" className="btn btn-primary">Commandez</a>
                </div>
            </div>
        </div>
    </div>;
})}
</div>

);
}*/


export default DetailContent;